import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, MapPin, ArrowRight, BadgeCheck } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { CLP, formatDate } from "@/lib/format";

function MiniWorkshop({ w }) {
  return (
    <Link to={`/taller/${w.id}`} className="group flex gap-3 rounded-xl border bg-background/70 p-2.5 hover:border-primary transition-colors" data-testid={`featured-workshop-${w.id}`}>
      {w.images?.[0] && <img src={fileUrl(w.images[0])} alt="" className="w-16 h-16 rounded-lg object-cover shrink-0" />}
      <div className="min-w-0 text-sm">
        <p className="font-semibold truncate group-hover:text-primary">{w.name}</p>
        <p className="text-xs text-muted-foreground">{formatDate(w.next_session?.starts_at)}</p>
        <p className="text-xs font-semibold">{CLP(w.effective_price_clp ?? w.price_clp)}</p>
      </div>
    </Link>
  );
}

export function FeaturedMaestro() {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/featured-maestro").then((r) => setM(r.data)).catch(() => {}); }, []);
  if (!m) return null;
  const place = [m.commune, m.region].filter(Boolean).join(", ");
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8" data-testid="featured-maestro">
      <div className="rounded-3xl border bg-gradient-to-br from-primary/10 via-card to-card p-6 sm:p-8 grid md:grid-cols-[auto_1fr] gap-6 items-start animate-fade-up">
        <div className="flex md:flex-col items-center gap-4">
          {m.avatar ? <img src={fileUrl(m.avatar)} alt={m.name} className="w-24 h-24 sm:w-28 sm:h-28 rounded-full object-cover ring-4 ring-primary/20" />
            : <span className="grid place-items-center w-24 h-24 rounded-full bg-primary/15 text-primary text-3xl font-bold">{m.name?.[0]}</span>}
        </div>
        <div className="min-w-0">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-coral"><Star className="w-4 h-4 fill-current" />Maestro de la Semana</span>
          <h2 className="mt-1 font-display text-2xl sm:text-3xl font-extrabold flex items-center gap-2" data-testid="featured-name">{m.name}<BadgeCheck className="w-6 h-6 text-primary shrink-0" /></h2>
          <p className="text-sm text-muted-foreground flex flex-wrap gap-x-3">{m.profession && <span>{m.profession}</span>}{place && <span className="inline-flex items-center gap-1"><MapPin className="w-3.5 h-3.5" />{place}</span>}</p>
          {(m.blurb || m.bio) && <p className="mt-3 text-sm sm:text-base leading-relaxed line-clamp-3" data-testid="featured-blurb-text">{m.blurb || m.bio}</p>}
          {m.workshops.length > 0 && <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">{m.workshops.map((w) => <MiniWorkshop key={w.id} w={w} />)}</div>}
          <Link to={`/maestro/${m.business_id}`} className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary hover:underline" data-testid="featured-profile-link">Ver perfil y talleres <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </div>
    </section>
  );
}
